<template>
  <div class="form5">
    <div class="form5_left">
      <el-form
        :model="form"
        label-width="auto"
        style="max-width: 600px"
        label-position="top"
        :rules="rules"
        ref="ruleForm"
        status-icon
      >
        <el-form-item
          label="自定义地图(双击添加或者消除)"
          v-if="dataForm2.mapSelect == '自定义地图'"
        >
          <CustomeMap class="map" ref="CavMap"></CustomeMap>
        </el-form-item>

        <el-form-item label="经纬度">
          <el-col :span="5">
            <el-input v-model="form.lat" />
          </el-col>
          <el-col :span="2" class="text-center"> </el-col>
          <el-col :span="5">
            <el-input v-model="form.lng" />
          </el-col>
          <el-col :span="2" class="text-center"> </el-col>
          <el-col :span="4">
            <el-button type="primary" @click="isShow = true"
              >打开地图</el-button
            >
          </el-col>
        </el-form-item>
        <el-form-item label="地点名称" prop="address">
          <el-input v-model="form.address" />
        </el-form-item>
        <h2>关卡位置提示</h2>
        <br />
        <br />
        <el-form-item label="地点提示标题">
          <el-input v-model="form.addressTipName" />
        </el-form-item>
        <el-form-item label="地点提示内容">
          <el-input v-model="form.addressTipContent" type="textarea" />
        </el-form-item>
        <el-form-item label="关卡位置提示图">
          <VueDraggable ref="el" v-model="fileList2" class="content">
            <div
              v-for="(item, index) in fileList2"
              :key="item.id"
              class="lunBo"
            >
              <el-image
                :src="item.url"
                :fit="'contain'"
                class="elImg"
              ></el-image>
              <span class="clearImg" @click="clearImage2(index)">删除图片</span>
            </div>
          </VueDraggable>
          <el-upload
            :file-list="fileList2"
            :action="UpdateApi"
            :on-success="handleAvatarSuccess2"
            :before-upload="beforeAvatarUpload2"
            :show-file-list="false"
            list-type="picture-card"
            style="margin-top: 10px; margin-left: 10px"
          >
            <el-icon class="avatar-uploader-icon"><Plus /></el-icon>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
    <Map
      :isShow="isShow"
      @onMapClose="handleCloseMap"
      @onSubmit="handleSubmit"
    ></Map>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive } from "vue";
import { Plus } from "@element-plus/icons-vue";
import { ElNotification, FormRules, UploadProps } from "element-plus";
import MapContainer from "@/components/content/MapContainer.vue";
import Map from "@/components/map/index.vue";
import { VueDraggable } from "vue-draggable-plus";
import CustomeMap from "@/components/canvans/CustomeMap.vue";
const validateNotEmpty = (rule: any, value: string, callback: any) => {
  if (value.trim() === "") {
    callback(new Error(rule.message));
  } else {
    callback();
    0;
  }
};
export default defineComponent({
  name: "App",
  components: { VueDraggable, Map, MapContainer, Plus, CustomeMap },
  props: ["dataForm", "dataForm2"],
  data(): any {
    return {
      form: {
        addressTipName: "",
        address: "",
        lat: 0,
        lng: 0,
        tipCover: "",
        addressTipContent: "",
      },
      fileList: [],
      fileList2: [],
      isShow: false,
      dialogImageUrl: "",
      dialogVisible: false,
      loading: false,
      rules: reactive<FormRules>({
        address: [
          {
            required: true,
            message: "景点知识不能为空",
            trigger: "blur",
            validator: validateNotEmpty,
          },
        ],
      }),
    };
  },
  computed: {
    doubledCounter(): number {
      return this.counter * 2;
    },
    allowUpload() {
      return this.form.tipCover !== "" && this.form.tipCover !== null;
    },
    UpdateApi() {
      return process.env.VUE_APP_Update_API;
    },
  },
  watch: {
    fileList2: {
      handler(newVal, oldVal) {
        if (this.fileList2 != []) {
          const a = this.fileList2
            .map((item: any) => {
              return item.url;
            })
            .join(",");

          this.form.tipCover = a;
        }
      },
      immediate: true,
      deep: true, // 可以深度检测到 person 对象的属性值的变化
    },
    dataForm: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.updateForm(newVal);
        }
      },
    },
    dataForm2: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.updateMap(newVal);
        }
      },
    },
  },
  mounted() {
    // setTimeout(() => {
    //   this.form.addressTipName = this.dataForm.addressTipName;
    //   this.form.address = this.dataForm.address;
    //   this.form.lat = this.dataForm.lat;
    //   this.form.lng = this.dataForm.lng;
    //   this.form.tipCover = this.dataForm.tipCover;
    //
    //   if (this.dataForm.tipCover != null) {
    //     this.fileList2 = this.dataForm.tipCover.split(",").map((url, index) => {
    //       return { url, uid: index, name: `file-${index}` };
    //     });
    //   }
    //
    //   const CavMap: any = this.$refs.CavMap;
    //
    //   if (CavMap) {
    //     CavMap.setMap(this.dataForm2.customizeMap); // 调用子组件的方法保存图片
    //   }
    //
    //   this.form.addressTipContent = this.dataForm.addressTipContent;
    // }, 200);
  },
  methods: {
    updateForm(dataForm) {
      // 更新表单字段
      this.form.addressTipName = dataForm.addressTipName;
      this.form.address = dataForm.address;
      this.form.lat = dataForm.lat;
      this.form.lng = dataForm.lng;
      this.form.tipCover = dataForm.tipCover;
      this.form.addressTipContent = dataForm.addressTipContent;

      // 更新文件列表
      if (dataForm.tipCover) {
        this.fileList2 = dataForm.tipCover.split(",").map((url, index) => ({
          url,
          uid: index,
          name: `file-${index}`,
        }));
      }
    },
    updateMap(dataForm2) {
      this.$nextTick(() => {
        const CavMap = this.$refs.CavMap;
        if (CavMap && dataForm2.customizeMap) {
          CavMap.setMap(dataForm2.customizeMap);
        }
      });
    },
    beforeAvatarUpload(file: File) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        ElNotification.warning({
          message: "请上传png/jpg",
          offset: 100,
          duration: 3000,
        });
        return false;
      }
      if (!isLt2M) {
        ElNotification.warning({
          message: "图片必须小于5m",
          offset: 100,
          duration: 3000,
        });
        return false;
      }

      // Display uploaded avatar
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.form.tipCover = reader.result as string;
      };

      return true;
    },
    handleAvatarSuccess(response: any) {
      this.form.tipCover = response.data.returnFileUrl;
    },
    handlePictureCardPreview(uploadFile: any): UploadProps["onPreview"] | void {
      this.dialogImageUrl = uploadFile.url!;
      this.dialogVisible = true;
    },
    handleRemove(
      uploadFile: any,
      uploadFiles: any
    ): UploadProps["onRemove"] | void {
      console.log(uploadFile, uploadFiles);
    },
    clearImage() {
      this.form.tipCover = "";
      this.fileList = [];
    },
    handleCloseMap() {
      this.isShow = false;
    },
    clearImage2(index: number) {
      // 删除对应索引的对象
      this.fileList2.splice(index, 1);
      console.log(this.fileList2);
    },
    handleAvatarSuccess2(response: any) {
      if (response.code == 200) {
        // 将文件 URL 包装成对象
        this.fileList2.push({
          url: response.data.returnFileUrl, // 图片的 URL
          uid: Date.now(), // 唯一标识符，可使用时间戳
          name: "图片名称", // 可以使用实际文件名或自定义
          status: "finished", // 状态为完成上传
        });
      }
    },
    beforeAvatarUpload2(file: File) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        ElNotification.warning({
          message: "请上传png/jpg",
          offset: 100,
          duration: 3000,
        });
        return false;
      }
      if (!isLt2M) {
        ElNotification.warning({
          message: "图片必须小于5m",
          offset: 100,
          duration: 3000,
        });
        return false;
      }

      return this.fileList2.length < 5;
    },
    //保存地图
    handleSubmit(coord: string, keyword: string) {
      this.form.lat = parseFloat(coord.split(",")[0]);
      this.form.lng = parseFloat(coord.split(",")[1]);
      this.form.address = keyword;
      this.isShow = false;
    },
  },
});
</script>

<style lang="less" scoped>
.form5 {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  &_left {
    width: 100%;
  }
  &_right {
    width: 50%;
    background: red;
    position: relative;

    .search {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}

.box {
  width: 100px;
  height: 100px;
}

.avatar-uploader .avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
}

、.avatar-uploader .avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.avatar-uploader {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.avatar-uploader:hover {
  border-color: var(--el-color-primary);
}

.content {
  width: 40vw;
  height: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;

  .lunBo {
    width: 150px;
    height: 150px;
    margin-left: 10px;
    margin-top: 10px;
    position: relative;

    .elImg {
      width: 100%;
      height: 100%;
      transition: opacity 0.3s ease; /* 添加一个平滑的过渡效果 */
    }

    .clearImg {
      position: absolute;
      left: 30%;
      top: 40%;
      z-index: 100;
      display: none;
      color: #000;
    }

    &:hover {
      .elImg {
        opacity: 0.5;
      }

      .clearImg {
        display: block;
        font-weight: bold;
      }
    }
  }
}
</style>
